import React, { useEffect, useState } from "react";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Moment } from "moment";
import { getAllLoanStatus } from "../../../apis/auth";

const LoanStatus = () => {
  const [allLoanData, setLoanData] = useState<LoanData[]>([]);
  const [filteredData, setFilteredData] = useState<LoanData[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string | null>(null);
  const [loansData, setLoansData] = useState<any>();
  const userInfo = JSON.parse(sessionStorage.getItem("info"));

  useEffect(() => {
    fetchAllLoans();
  }, []);

  useEffect(() => {
    if (!selectedStatus) {
      setFilteredData(loansData);
    } else {
      const filteredLoans = loansData.filter(
        (loan: any) => loan.Status === selectedStatus
      );
      setFilteredData(filteredLoans);
    }
  }, [selectedStatus, loansData]);

  const fetchAllLoans = async () => {
    try {
      const payload = {
        id: userInfo?.id,
        type: userInfo?.type,
      };
      const res = await getAllLoanStatus(payload);
      const formattedData = res?.data?.loanDetails?.map(
        (loan: any, index: number) => ({
          key: index + 1,
          EmpId: loan.id || "-",
          Name: loan.customer.full_name || "-",
          Email: loan.customer.email || "-",
          Phone: loan.customer.phoneNumber1 || "-",
          loanAdddate: loan.createdAt
            ? new Date(loan.createdAt).toLocaleDateString()
            : "-",
          approvalAmount: loan?.approvalAmount || "--",
          approvalDate: loan?.approvalDate || "",
          geo_location: loan.geo_location || "-",
          address: loan.address || "-",
          Status: loan.status || "Pending",
          customerAccountNumber: loan.customer.loanAccountNumber || "--",
          loanAccountNumber: loan.loan_id || "--",
          id: loan.id,
          allDetails: loan,
        })
      );
      setLoansData(formattedData);
    } catch (err) {
      console.error("Error fetching loans:", err);
    }
  };

  type LoanData = {
    key: number;
    EmpId: string;
    Name: string;
    Image: string;
    Email: string;
    Phone: string;
    loanAdddate: string;
    approvalAmount: string;
    approvalDate: string;
    geo_location: string;
    address: any;
    Status: string;
    loanAccountNumber: string;
    customerAccountNumber: string;
    id: any;
    allDetails: any;
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <span>{text}</span>,
      sorter: (a: LoanData, b: LoanData) => a.EmpId.localeCompare(b.EmpId),
    },
    {
      title: "Loan Add Date",
      dataIndex: "loanAdddate",
      sorter: (a: LoanData, b: LoanData) =>
        new Date(a.loanAdddate).getTime() - new Date(b.loanAdddate).getTime(),
    },
    {
      title: "Customer Account Number",
      dataIndex: "customerAccountNumber",
      sorter: (a: LoanData, b: LoanData) =>
        a.customerAccountNumber.localeCompare(b.customerAccountNumber),
      render: (_: any, record: LoanData) => (
        <div>{record.customerAccountNumber}</div>
      ),
    },
    {
      title: "Loan Account Number",
      dataIndex: "loanAccountNumber",
      sorter: (a: LoanData, b: LoanData) =>
        a.loanAccountNumber.localeCompare(b.loanAccountNumber),
      render: (_: any, record: LoanData) => (
        <div>{record.loanAccountNumber}</div>
      ),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: LoanData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: LoanData, b: LoanData) => a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: LoanData, b: LoanData) => a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: LoanData, b: LoanData) => a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Loan Approval Date",
      dataIndex: "approvalDate",
      sorter: (a: LoanData, b: LoanData) =>
        new Date(a.approvalDate).getTime() - new Date(b.approvalDate).getTime(),
    },
    {
      title: "Loan Approval Amount",
      dataIndex: "approvalAmount",
      sorter: (a: LoanData, b: LoanData) =>
        a.approvalAmount.localeCompare(b.approvalAmount),
    },
    {
      title: "File Charges",
      dataIndex: "Name",
      render: (_: any, record: LoanData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">
              {record.allDetails.approvalfilecharge}
            </p>
          </div>
        </div>
      ),
      sorter: (a: LoanData, b: LoanData) =>
        a.allDetails.approvalfilecharge.localeCompare(
          b.allDetails.approvalfilecharge
        ),
    },
    {
      title: "Other Charges",
      dataIndex: "Name",
      render: (_: any, record: LoanData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <p className="text-dark mb-0">{record.allDetails.othercharges}</p>
          </div>
        </div>
      ),
      sorter: (a: LoanData, b: LoanData) =>
        a.allDetails.othercharges.localeCompare(b.allDetails.othercharges),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: LoanData) => (
        <span className="dropdown">
          <div
            className={`badge  btn btn-white ${
              text === "Active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
            data-bs-toggle="dropdown"
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </div>
        </span>
      ),
      sorter: (a: LoanData, b: LoanData) => a.Status.localeCompare(b.Status),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: LoanData) => (
        <Link
          to={`/customer-view?id=${record?.allDetails.customer.id}`}
          className="btn btn-primary d-flex align-items-center"
        >
          {"Details"}
        </Link>
      ),
    },
  ];

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allLoanData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "LoanData");
    XLSX.writeFile(workbook, "employee_data.xlsx");
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content" style={{ background: "#0000000f" }}>
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div
                className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
                style={{
                  justifyContent: "space-around",
                  width: "100%",
                }}
              >
                <div className="dropdown me-3">
                  <Link
                    style={{
                      background: "#b4b4b447",
                      color: "#00000057",
                    }}
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus || "Select Status"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    {["pending", "approved", "reject", "disbursed"].map(
                      (status) => (
                        <li key={status}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => setSelectedStatus(status)}
                            style={{ cursor: "pointer" }}
                          >
                            {status}
                          </div>
                        </li>
                      )
                    )}
                  </ul>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table columns={columns} dataSource={filteredData} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoanStatus;
